import { Base } from "./base";
import { LocaleString } from "./locale";

export type RecipientType = "all" | "draft";

export const RecipientTypes: RecipientType[] = ["all", "draft"];

export interface ListSchedule extends Base {
  list_uuid: string;
  send_at: string;
  recipients: RecipientType;
  subject: LocaleString;
  message: LocaleString;
}
